import type { BlockMetadataIndicator } from 'types/builderBlockMetadata';

/** Row shape expected by `getPropertyTableRows` (property table grid) */
export default function mapBlockMetadataIndicatorsToPropertyTableRows(
  indicators: BlockMetadataIndicator[] | undefined,
) {
  if (!indicators?.length) return [];
  return indicators.map((data) => ({
    id: data.id,
    warning: data.warning,
    type: data.type,
    'Block indicators': data.name,
    Type: data.indicator_type,
    Formula: data.formula ?? '',
    indicator_type: data.indicator_type,
    'Help text': data.help ?? '',
    Format: data.format,
    'Roll up type': data.data_type,
    'Display as output': data.is_favourite,
    'Display as sub-total': data.output_format,
    'Default chart type': data.chart_type,
  }));
}
